(function () {
  function formatMoney(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CO');
  }

  /* Compara imágenes por nombre de archivo: el id de "featured_image" que
     trae el JSON de variantes (sistema clásico) no coincide con el id de
     "media" que usa Liquid (sistema unificado moderno) para el mismo
     archivo, así que el nombre de archivo es la única referencia común. */
  function filenameOf(url) {
    if (!url) return '';
    return url.split('?')[0].split('/').pop();
  }

  function initGallery(root) {
    var main = root.querySelector('[data-vp-product-main] img');
    var thumbs = root.querySelectorAll('[data-vp-product-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* La imagen principal trae "srcset" (versiones en varios
           tamaños) generado por Shopify; el navegador lo sigue usando
           aunque cambiemos "src", así que hay que quitarlo para que el
           cambio de foto se vea de verdad. */
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = btn.getAttribute('data-full');
        var zoomSrc = btn.getAttribute('data-zoom');
        if (zoomSrc) main.setAttribute('data-zoom-src', zoomSrc);
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* Deslizar con el dedo sobre la foto grande para pasar a la siguiente
     o anterior. Reutiliza los botones de miniatura (misma lógica de
     cambio de foto, zoom y miniatura activa). */
  function initSwipe(root) {
    var box = root.querySelector('[data-vp-product-main]');
    var img = box ? box.querySelector('img') : null;
    if (!box || !img) return;
    function visibleThumbs() {
      return Array.prototype.filter.call(root.querySelectorAll('[data-vp-product-thumb]'), function (t) {
        return !t.hidden && t.offsetParent !== null;
      });
    }
    if (visibleThumbs().length < 2) return;
    var startX = 0, startY = 0, dx = 0, tracking = false, horizontal = null;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      dx = 0; tracking = true; horizontal = null;
      img.style.transition = 'none';
    }, { passive: true });
    box.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var mx = e.touches[0].clientX - startX, my = e.touches[0].clientY - startY;
      if (horizontal === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) horizontal = Math.abs(mx) > Math.abs(my);
      if (!horizontal) return;
      dx = mx;
      img.style.transform = 'translateX(' + dx + 'px)';
      img.style.opacity = String(1 - Math.min(Math.abs(dx) / box.offsetWidth, 0.6));
    }, { passive: true });
    function end() {
      if (!tracking) return;
      tracking = false;
      var list = visibleThumbs();
      var current = list.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (current < 0) current = 0;
      var dir = 0;
      if (horizontal && Math.abs(dx) > 45) dir = dx < 0 ? 1 : -1;
      var next = dir ? (current + dir + list.length) % list.length : current;
      img.style.transition = 'transform .22s ease, opacity .22s ease';
      if (!dir) { img.style.transform = ''; img.style.opacity = ''; return; }
      img.style.transform = 'translateX(' + (dir > 0 ? -box.offsetWidth : box.offsetWidth) + 'px)';
      img.style.opacity = '0';
      setTimeout(function () {
        list[next].click();
        list[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        img.style.transition = 'none';
        img.style.transform = 'translateX(' + (dir > 0 ? box.offsetWidth * 0.35 : -box.offsetWidth * 0.35) + 'px)';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            img.style.transition = 'transform .25s ease, opacity .25s ease';
            img.style.transform = '';
            img.style.opacity = '';
          });
        });
      }, 200);
    }
    box.addEventListener('touchend', end);
    box.addEventListener('touchcancel', end);
  }

  function initImageZoom(root) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var container = root.querySelector('[data-vp-zoom-enabled]');
    var main = container ? container.querySelector('img') : null;
    if (!container || !main) return;

    /* Al entrar, si hay una versión en más resolución (data-zoom-src),
       la usa para que el acercamiento se vea nítido y no borroso. */
    container.addEventListener('mouseenter', function () {
      var zoomSrc = main.getAttribute('data-zoom-src');
      if (zoomSrc && main.src !== zoomSrc) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = zoomSrc;
      }
      container.classList.add('is-zooming');
    });

    container.addEventListener('mousemove', function (e) {
      var rect = container.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      main.style.transformOrigin = x + '% ' + y + '%';
    });

    container.addEventListener('mouseleave', function () {
      container.classList.remove('is-zooming');
    });
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-vp-qty-input]');
    var minus = root.querySelector('[data-vp-qty-minus]');
    var plus = root.querySelector('[data-vp-qty-plus]');
    if (!input || !minus || !plus) return;

    /* El límite real (cuántas unidades hay) lo pone initVariants() en el
       atributo "max" del input cada vez que cambia la variante elegida;
       aquí solo se respeta ese límite, sea cual sea en cada momento. */
    function clamp(value) {
      var max = input.getAttribute('max');
      var result = Math.max(1, value);
      if (max !== null && max !== '') result = Math.min(result, parseInt(max, 10));
      return result;
    }

    minus.addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || 1) - 1);
    });
    plus.addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || 1) + 1);
    });
    input.addEventListener('change', function () {
      input.value = clamp(parseInt(input.value, 10) || 1);
    });
  }

  function initVariants(root) {
    var form = root.querySelector('[data-vp-product-form]');
    var variantsScript = root.querySelector('[data-vp-product-variants]');
    if (!form || !variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('[data-vp-product-variant-id]');
    var priceEl = root.querySelector('.vp-product__price');
    var comparePriceEl = root.querySelector('.vp-product__price--compare');
    var submitBtn = root.querySelector('[data-vp-product-submit]');
    var submitText = root.querySelector('[data-vp-product-submit-text]');
    var addLabel = submitText ? submitText.textContent : 'Añadir al carrito';
    var soldOutLabel = root.getAttribute('data-vp-sold-out-label') || 'Agotado';
    var mainImg = root.querySelector('[data-vp-product-main] img');
    var thumbs = root.querySelectorAll('[data-vp-product-thumb]');
    var qtyInput = root.querySelector('[data-vp-qty-input]');
    var stockBadge = root.querySelector('[data-vp-stock-badge]');

    var groups = root.querySelectorAll('[data-vp-option-index]');

    function selectedOptions() {
      var selected = [];
      groups.forEach(function (group) {
        var active = group.querySelector('.vp-product__pill.is-selected');
        selected.push(active ? active.getAttribute('data-vp-option-value') : null);
      });
      return selected;
    }

    function findVariant() {
      var selected = selectedOptions();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    /* Tacha un color/talla en cuanto TODAS las variantes que tienen ese
       valor están agotadas — para que se vea de una vez que no hay, sin
       necesidad de seleccionarlo primero. */
    groups.forEach(function (group, i) {
      var optKey = 'option' + (i + 1);
      group.querySelectorAll('.vp-product__pill').forEach(function (pill) {
        var val = pill.getAttribute('data-vp-option-value');
        var matching = variants.filter(function (v) { return v[optKey] === val; });
        var noneAvailable = matching.length > 0 && matching.every(function (v) { return !v.available; });
        pill.classList.toggle('is-unavailable', noneAvailable);
      });
    });

    function update() {
      var variant = findVariant();
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        var sep = variant.featured_image.src.indexOf('?') > -1 ? '&' : '?';
        var fullSrc = variant.featured_image.src + sep + 'width=1200';
        var zoomSrc = variant.featured_image.src + sep + 'width=2000';
        /* El "srcset" que Shopify genera pisa el "src" nuevo si no se
           quita primero (mismo caso que al hacer clic en una miniatura). */
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = fullSrc;
        mainImg.setAttribute('data-zoom-src', zoomSrc);
        if (thumbs && thumbs.length) {
          var targetFile = filenameOf(variant.featured_image.src);
          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', filenameOf(t.getAttribute('data-full')) === targetFile);
          });
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        if (submitText) submitText.textContent = variant.available ? addLabel : soldOutLabel;
      }
      var limited = !root.hasAttribute('data-vp-sin-limite') && variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny';
      if (qtyInput) {
        if (limited) {
          var cap = Math.max(1, variant.inventory_quantity);
          qtyInput.setAttribute('max', cap);
          if ((parseInt(qtyInput.value, 10) || 1) > cap) qtyInput.value = cap;
        } else {
          qtyInput.removeAttribute('max');
        }
      }
      if (stockBadge) {
        var outOfStock = limited && variant.inventory_quantity <= 0;
        var lowStock = limited && variant.inventory_quantity > 0 && variant.inventory_quantity < 10;
        if (outOfStock) {
          stockBadge.textContent = 'Sin existencias';
          stockBadge.hidden = false;
        } else if (lowStock) {
          stockBadge.textContent = variant.inventory_quantity === 1
            ? 'Última unidad'
            : 'Últimas ' + variant.inventory_quantity + ' unidades';
          stockBadge.hidden = false;
        } else {
          stockBadge.hidden = true;
        }
      }
    }

    groups.forEach(function (group) {
      group.querySelectorAll('.vp-product__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.vp-product__pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          update();
        });
      });
    });

    /* Sentido contrario: al tocar una miniatura, selecciona el color (u
       otras opciones) de la variante dueña de esa foto — mismo emparejado
       por nombre de archivo que usa update() para la miniatura activa. */
    if (thumbs && thumbs.length && groups.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var file = filenameOf(thumb.getAttribute('data-full'));
          var match = variants.find(function (v) {
            return v.featured_image && filenameOf(v.featured_image.src) === file;
          });
          if (!match) return;
          groups.forEach(function (group, i) {
            var val = match['option' + (i + 1)];
            if (val == null) return;
            group.querySelectorAll('.vp-product__pill').forEach(function (p) {
              p.classList.toggle('is-selected', p.getAttribute('data-vp-option-value') === val);
            });
          });
          update();
        });
      });
    }
  }

  function initZoom(root) {
    var zoomBtn = root.querySelector('[data-vp-product-zoom]');
    var main = root.querySelector('[data-vp-product-main] img');
    if (!zoomBtn || !main) return;
    zoomBtn.addEventListener('click', function () {
      window.open(main.src, '_blank', 'noopener');
    });
  }

  function initTabs(root) {
    var tabs = root.querySelector('[data-vp-product-tabs]');
    if (!tabs) return;
    var buttons = tabs.querySelectorAll('[data-vp-tab-btn]');
    var panels = tabs.querySelectorAll('[data-vp-tab-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-vp-tab-btn');
        buttons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var match = panel.getAttribute('data-vp-tab-panel') === target;
          panel.classList.toggle('is-active', match);
          panel.hidden = !match;
        });
      });
    });
  }

  /* El formulario de esta ficha no está envuelto en <product-form> de Dawn,
     así que el envío nativo mandaba al cliente a la página /cart. Aquí se
     agrega por AJAX y se abre el carrito lateral (cart-drawer) ya repintado. */
  function initAddToCart(root) {
    var form = root.querySelector('[data-vp-product-form]');
    var btn = root.querySelector('[data-vp-product-submit]');
    if (!form || !btn) return;
    var errorEl = root.querySelector('[data-vp-buy-now-error]');

    form.addEventListener('submit', function (e) {
      var cart = document.querySelector('cart-drawer');
      if (!cart || typeof cart.renderContents !== 'function') return; /* sin carrito lateral: envío normal */
      e.preventDefault();
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      var label = btn.querySelector('[data-vp-product-submit-text]');
      var originalText = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = 'Agregando…';
      if (errorEl) errorEl.hidden = true;

      var data = new FormData(form);
      data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      data.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (json.status) throw json;
          cart.renderContents(json);
          if (window.VPCarrito) window.VPCarrito.burbuja();
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = (err && (err.description || err.message)) || 'No se pudo agregar al carrito. Puede que no queden suficientes unidades disponibles.';
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          btn.disabled = false;
          if (label) label.textContent = originalText;
        });
    });
  }

  function initSizeGuide() {
    var modal = document.querySelector('[data-vp-size-guide]');
    var openBtns = document.querySelectorAll('[data-vp-size-guide-open]');
    if (!modal || !openBtns.length) return;
    var closeEls = modal.querySelectorAll('[data-vp-size-guide-close]');

    var open = function () {
      var sel = document.querySelector('.vp-product__pill.is-selected');
      var val = sel ? (sel.getAttribute('data-vp-option-value') || sel.textContent).trim() : '';
      modal.querySelectorAll('[data-vp-size-row]').forEach(function (r) {
        r.classList.toggle('is-current', !!val && r.getAttribute('data-vp-size-row') === val);
      });
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    var close = function () {
      modal.hidden = true;
      document.body.style.overflow = '';
    };

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function init() {
    document.querySelectorAll('.vp-product').forEach(function (root) {
      initGallery(root);
      initSwipe(root);
      initQuantity(root);
      initVariants(root);
      initZoom(root);
      initImageZoom(root);
      initTabs(root);
      initAddToCart(root);
    });
    initSizeGuide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
